import React, { PureComponent } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Cascader } from 'antd';

import { BaseInputProps } from '../types';

export interface InstrumentArrayProps extends BaseInputProps {
  value?: string[];

  onChange?(val: string[]): void;

  /**
   * @default true
   * */
  multiple?: boolean;
  options?: string[];
}

export class InstrumentArray extends PureComponent<InstrumentArrayProps> {
  state = {
    searchText: '',
    value: this.props.value?.map(it => {
      const instrumentSplit = it.split('-');
      return [
        'All',
        instrumentSplit[1],
        `${instrumentSplit[1]}-${instrumentSplit[2]}`,
        `${instrumentSplit[1]}-${instrumentSplit[2]}-${instrumentSplit[3]}`,
      ];
    }),
  };

  onChange = (val: any) => {
    // console.log('val=========', val);
    this.setState(pre => ({ ...pre, value: val }));
    let res = [];
    if (val.length === 1 && val[0].length === 1 && val[0][0] === 'All') {
      this.props.onChange?.(this.props.options || []);

      return;
      //   res = Array.from(new Set(this.props.options?.map((it) => it.split('-')[1])));
    } else {
      res = val.map((it: string[]) => it.filter(v => v !== 'All'));
    }

    if (val.length <= 0) {
      this.props.onChange?.([]);
      return;
    }
    const result = val.reduce(
      (pre: string[], cur: string[]) => [
        ...pre,
        ...(this.props.options?.filter(it =>
          it.includes(cur[cur.length - 1]),
        ) || []),
      ],
      [] as string[],
    );
    // console.log('result=========', result);
    this.props.onChange?.(Array.from(new Set(result)));
  };

  render() {
    const expiries = Array.from(
      new Set(this.props.options?.map(it => it.split('-')[1])),
    );

    const token = this.props.options?.[0]?.split('-')[0];

    let instrumentOptions = expiries?.map(it => {
      const insts = Array.from(
        new Set(
          this.props.options?.map(inst => inst.slice(0, inst.length - 2)),
        ),
      );

      return {
        label: it,
        value: it,
        children: insts
          ?.filter($it => $it.includes(`-${it}`))
          .map($it => {
            return {
              label: $it.split('-')[2],
              value: `${it}-${$it.split('-')[2]}`,
              children: ['C', 'P'].map(side => ({
                label: side,
                value: `${it}-${$it.split('-')[2]}-${side}`,
              })),
            };
          }),
      };
    });

    instrumentOptions = [
      {
        value: 'All',
        label: 'All',
        children: instrumentOptions,
      },
    ];

    const value = Array.from(
      new Set(this.props.value?.map(it => it.split('-')[1])),
    )?.map(it => {
      const insts = Array.from(
        new Set(this.props.value?.map(inst => inst.slice(0, inst.length - 2))),
      );
      return {
        label: it,
        value: it,
        children: insts
          ?.filter($it => $it.includes(it))
          .map($it => ({
            label: $it.split('-')[2],
            value: `${it}-${$it.split('-')[2]}`,
            children: this.props.value
              ?.filter(inst => inst.includes(`${it}-${$it.split('-')[2]}`))
              .map(side => ({
                label: side.slice(side.length - 1, side.length),
                value: `${it}-${$it.split('-')[2]}-${side.slice(
                  side.length - 1,
                  side.length,
                )}`,
              })),
          })),
      };
    });

    // if (this.props.options?.length)
    //   instrumentOptions.unshift({ label: 'All', value: 'All', children: [] });
    // console.log('this.value=========', this.props.value, value);

    return this.props.readonly ? (
      <Cascader
        value={[]}
        placeholder="Click to show more"
        options={value}
        maxTagCount="responsive"
        expandTrigger="hover"
        suffixIcon={<DownOutlined />}
      />
    ) : (
      <div>
        <Cascader
          style={{ width: '100%' }}
          value={this.state.value}
          placeholder="Choose"
          options={instrumentOptions}
          searchValue={this.state.searchText}
          onSearch={v => this.setState(pre => ({ ...pre, searchText: v }))}
          onChange={this.onChange}
          multiple
          maxTagCount="responsive"
          showSearch={{
            render: (_, path) => {
              const str = path
                .map(it => (it.label === 'All' ? token : it.label))
                .join('-');
              return <div key={str}>{str}</div>;
            },
          }}
          expandTrigger="hover"
          suffixIcon={<DownOutlined />}
          displayRender={label =>
            label.length === 1
              ? label
              : label.map(it => (it === 'All' ? token : it)).join('-')
          }
        />
      </div>
    );
  }
}
